<div class="sure__wrapper d-flex align-items-center justify-content-around">
  <div class="sure__text">
    {{ data.text }}
  </div>
  <div class="sure__buttons">
    <button class="button button__cancel sure__button" (click)="reject()">
      {{ data.rejectLabel || "Don't save" }}
    </button>
    <button class="button button__lightblue sure__button" (click)="accept()">
      {{ data.acceptLabel || 'Save' }}
    </button>
  </div>
</div>
